<template>
  <div>
    <a
      class="btn btn-outline-primary rounded-pill btn-sm fw-500"
      v-if="cartDetails.discount == 0 && cart.length > 0"
      v-on:click="addDiscount()"
    >
      <i class="fa fa-plus"></i> เพิ่มส่วนลด</a
    >
    <a
      class="btn btn-outline-primary rounded-pill btn-sm fw-500"
      v-if="cartDetails.discount && cartDetails.discount != 0"
      v-on:click="disableDiscount()"
      >{{ cartDetails.discount_text }}</a
    >
    <div
      class="modal fade"
      id="modal-add-discount"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="modal-add-discount-label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <p class="text-black fw-500 text-center">กำหนดส่วนลด</p>
              </div>
              <div class="col-12 text-center mb-4">
                <div
                  class="btn-group btn-group-lg"
                  role="group"
                  aria-label="Small Horizontal Primary"
                >
                  <button
                    type="button"
                    v-bind:class="`btn btn-outline-primary btn-lg ${
                      discountType == 0 ? 'active' : ''
                    }`"
                    v-on:click="changeDiscountType(0)"
                  >
                    ลดเป็นจำนวนเงิน (฿)
                  </button>
                  <button
                    type="button"
                    v-bind:class="`btn btn-outline-primary btn-lg ${
                      discountType == 1 ? 'active' : ''
                    }`"
                    v-on:click="changeDiscountType(1)"
                  >
                    ลดเป็นเปอร์เซ็นต์ (%)
                  </button>
                </div>
              </div>
              <div class="col-6 mx-auto">
                <div class="mb-4">
                  <label class="form-label text-black" for=""
                    >ระบุจำนวนที่ต้องการลด</label
                  >
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control form-control-lg text-end"
                      placeholder="0.00"
                      v-model="discountValue"
                    />
                    <span class="input-group-text text-black">
                      {{ discountType == 1 ? "%" : "฿" }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="w-100"></div>
              <div class="col-6 mx-auto">
                <div class="row">
                  <div class="col-6">
                    <p class="text-black fw-500 mb-3">ราคารวมก่อนส่วนลด</p>
                  </div>
                  <div class="col-6">
                    <p class="text-black fw-500 mb-3 text-end">
                      {{ cartDetails.total_text }}
                    </p>
                  </div>

                  <div class="col-6">
                    <p class="text-black fw-500">ส่วนลด</p>
                  </div>
                  <div class="col-6">
                    <p class="text-danger fw-500 text-end">
                      {{ cartDetails.discount_text }}
                    </p>
                  </div>

                  <div class="col-6">
                    <p class="text-black fs-3 fw-500">ราคารวม</p>
                  </div>
                  <div class="col-6">
                    <p class="text-black fs-3 fw-500 text-end">
                      {{ totalAfterDiscount }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="w-100"></div>
              <div class="col-6 mx-auto">
                <button
                  class="btn btn-primary btn-lg w-100"
                  v-on:click="
                    updateDiscount({
                      showModal: true,
                      isUseCustomerDiscount: false,
                    })
                  "
                >
                  ยืนยันการใช้ส่วนลด
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["cartDetails", "cart"],
  data() {
    return {
      discountValue: 0,
      discountType: 0,
      totalAfterDiscount: 0,
      discountTotal: 0,
    };
  },
  watch: {
    discountValue() {
      this.calculate();
    },
  },
  methods: {
    calculate() {
      this.discountTotal = this.discountValue;
      if (this.discountType == 1) {
        //discountType 1 = % , 0 = THB
        this.discountTotal =
          (this.cartDetails.subtotal + this.cartDetails.delivery_cost) *
          (this.discountValue / 100);
      }
      this.discountTotal =
        isNaN(this.discountTotal) || this.discountTotal == ""
          ? 0
          : this.discountTotal;
      this.cartDetails.discount = this.discountTotal;
      this.cartDetails.discount_text = parseFloat(
        this.discountTotal
      ).toLocaleString("th-TH", {
        maximumFractionDigits: 2,
      });
      this.totalAfterDiscount =
        this.cartDetails.subtotal +
        this.cartDetails.delivery_cost -
        this.cartDetails.discount;
      this.totalAfterDiscount =
        this.totalAfterDiscount <= 0 ? 0 : this.totalAfterDiscount;
      this.totalAfterDiscount = parseFloat(
        this.totalAfterDiscount
      ).toLocaleString("th-TH", {
        maximumFractionDigits: 2,
      });
    },
    changeDiscountType(type) {
      this.discountType = type;
      this.calculate();
    },
    updateDiscount() {
      this.$emit("confirm", {
        discount: this.discountTotal,
        isUseCustomerDiscount: false,
      });
      $("#modal-add-discount").modal("hide");
    },
    addDiscount() {
      this.calculate();
      $("#modal-add-discount").modal("show");
    },
    async disableDiscount() {
      let result = await mySwal.fire({
        title: "ยกเลิกการใช้ส่วนลด",
        text: "คุณแน่ใจที่จะยกเลิกการใช้ส่วนลดใช่หรือไม่",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-success m-1",
          cancelButton: "btn btn-danger m-1",
        },
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      });
      if (!result.isConfirmed) return;
      this.discountValue = 0;
      this.discountTotal = 0;
      this.totalAfterDiscount = 0;
      this.$emit("confirm", {
        discount: 0,
        isUseCustomerDiscount: false,
      });
    },
  },
};
</script>
